import request from '@/utils/request'
import { _c } from '@/utils'
import { UploadFileRes } from '@/api/common/common-api-type'

export type UploadFileAppType = 'ASR' | 'TTS' | 'MT' | 'OCR' | 'NLP'
// 依据能力区分类型
export type OCRSubAbilityType = 'TEXT' | 'BIZCARD' | 'TEMPLATE'

export interface IUploadParams {
  appType: UploadFileAppType
  subAbility?: OCRSubAbilityType
}
export function uploadFile (
  file: File,
  params?: IUploadParams, // 其他参数
  onUploadProgress?: (progress: ProgressEvent) => any,
) {
  const formData = new FormData()
  formData.append('file', file)
  if(params) {
    Object.entries(params).forEach(([key, val]) => {
      if(val) {
        formData.append(key, val)
      }
    })
  }
  return request<UploadFileRes>({
    method: 'post',
    url: _c('/api/common/file/upload', false),
    // showMessageOnError: false,
    data: formData,
    onUploadProgress,
  })
}

// 批量删除文件
export function batchDeleteFiles (
  fileIds: string[],
) {
  return request.delete('/api/common/file/delete', {
    params: { ids: fileIds.join(',') } // 根据接口文档要求,使用','分隔
  })
}

// 根据分片上传文件前端生成的文件标识查询最终上传完成后生成的文件id
export function getFileIdByFileUid(fileUid: string) {
  return request.get(`/api/common/file`, {
    params: {
      fileUid
    }
  })
}
